import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2'
import Loading from 'vue-loading-overlay';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vSelect from 'vue-select'

//css
import 'vue-loading-overlay/dist/vue-loading.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, axios)
Vue.use(Loading)
Vue.use(VueSweetalert2)

Vue.component('v-select', vSelect)
Vue.component('loading-overlay', Loading)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
